<template>
  <section>
    <b-row>
      <b-col>
          <validation-observer v-slot="{ invalid }">
              <b-card           
                >   
                  <template v-slot:header >
                    <div class="header-card">
                      Registrar ordenes de garantias
                    </div>
                  </template>
                  <b-row>
                  <b-col :md="12" style="margin-top:10px">
                      <sw-tableget
                        :tableItems="tableGBItems"
                        :tableSearch="tableGBSearch"
                        :tableOptions="tableGBoptions"
                        name="tableGet"
                        route="garantias_orden"
                        dataRoute="pacientes"
                        >
                        <template v-slot:modal>
                          <sw-modalregistrogarantia
                            v-if="openModal.modal.modal==='registrar'"
                            @save="saveForm"                     
                            >
                          </sw-modalregistrogarantia>
                          <sw-modalanularexamen
                            v-if="openModal.modal.modal==='Anular'"
                            @save="saveForm"
                            >
                          </sw-modalanularexamen>  
                        </template>
                      </sw-tableget>                  
                  </b-col>              
                </b-row>             
                                                  
              </b-card>           
          </validation-observer>
      </b-col>
    </b-row>          
  </section>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalregistrogarantia from '@/components/modals/registrogarantia.vue'
import SwModalanularexamen from '@/components/modals/anularexamen.vue'

export default { 
  name: "forms_saveform",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
     ValidationObserver,
     SwTableget,
     SwModalregistrogarantia,
     SwModalanularexamen
  }
}
</script>
